import Axios, { Method } from 'axios';
import _store from '@/store';
import Env from '@/services/env.service';

export default function(path: string, useAuth: boolean = true, rootUrl?: string) {
    rootUrl = rootUrl || Env.get('VUE_APP_API_ROOT');
    const token = useAuth ? _store.state.auth.authToken : '';
    let headers: any = useAuth ? { Authorization: 'Bearer ' + token } : {};
    if (Env.get('VUE_APP_NAMESPACE')) {
      headers['namespace'] = Env.get('VUE_APP_NAMESPACE');
    }
    const method: Method = 'DELETE';

    const req: any = { method, headers, withCredentials: true };

    if (/^\/\//.test(path) || /file:/.test(path)) throw new Error("Unsafe path for axios request");
    return Axios(rootUrl + path, req)
      .then((res: any) => {
        return res.data ? res.data : {};
      }, (err: any) => {
        // tslint:disable-next-line:no-console
        console.error(err);
        throw err;
      });
}
